import React from 'react';
import { useTranslation } from 'react-i18next';

export default function GoogleLogInLink(){
  const { t, i18n } = useTranslation();
  
  return <a className="mt-3 btn btn-light d-flex align-items-center justify-content-center rounded-pill" 
    style={{fontWeight:'bold',textTransform:'uppercase',width:"100%",height:"50px",color:'white',backgroundColor:'var(--vc-lightblue)'}} href="/user/google">
      <img className='me-2' src="/images/google_logo.png"/>
      <span>{t("login")} {t("by")} google</span>
    </a>
}